module.exports = __webpack_public_path__ + "img/bigsale.c64e263c.png";